import type {
  NavigationContext,
  NavigationPageUpdate,
} from '../../modules/albaran_factura/infra/DocumentNavigation';

const SET_CONTEXT = 'SET_CONTEXT';
const SET_PAGE = 'SET_PAGE';

interface DocumentNavigationState {
  context: NavigationContext | null;
}

interface DocumentNavigationActionContext {
  commit(
    mutation: string,
    payload: NavigationContext | NavigationPageUpdate,
  ): void;
}

const state: DocumentNavigationState = {
  context: null,
};

const getters = {
  context: (currentState: DocumentNavigationState): NavigationContext | null => (
    currentState.context
  ),
};

const mutations = {
  [SET_CONTEXT](currentState: DocumentNavigationState, context: NavigationContext): void {
    currentState.context = context;
  },
  [SET_PAGE](currentState: DocumentNavigationState, page: NavigationPageUpdate): void {
    currentState.context = currentState.context
      ? { ...currentState.context, ...page }
      : null;
  },
};

const actions = {
  setContext({ commit }: DocumentNavigationActionContext, context: NavigationContext): void {
    commit(SET_CONTEXT, context);
  },
  setPage({ commit }: DocumentNavigationActionContext, page: NavigationPageUpdate): void {
    commit(SET_PAGE, page);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
